import React, { useEffect, useState } from 'react';

import Effect from '../../../../dmView/components/EncounterColumn/Effect.js';
import { effectImgMap } from '../../../../dmView/constants.js';

const PlayerUiEffectContainer = ({ creature, socket }) => {
    const [effects, setEffects] = useState(creature.effectObjs);

    useEffect(() => {
        setEffects(creature.effectObjs);
    }, [creature.creatureGuid, creature.effectObjs]);

     const updateCreatureEffects = (event, effectName, type) => {
        event.stopPropagation(); 
        const alreadyExists = effects.some(e => e.effectName === effectName);
        
        let updatedEffects = []
        let newEffect = { effectName, addedBy: 'player', turnAdded: '1.1', duration: '∞' }
        
        if(alreadyExists) {
            updatedEffects = effects.filter(e => e.effectName !== effectName)
        } else {
            updatedEffects = [...effects, newEffect]
        }

        setEffects(updatedEffects)
        socket.emit('playerEffectChange', newEffect, alreadyExists ? "remove" : "add", creature.creatureGuid, "player");
    };

    return (
        <div className='effectsBarContainerPlayerUi editHpGrowPlayerUi'>
            <div className="effectsBarPlayerUi" onClick={(event) => event.stopPropagation()}>
                {Object.entries(effectImgMap).map(([effectName, image]) => (
                    <Effect
                        key={`${creature.creatureGuid}-${effectName}`}
                        currentEffects={effects}
                        updateCreatureEffects={updateCreatureEffects}
                        effectName={effectName}
                        image={image}
                    />
                ))}
            </div>
        </div>
    );
};

export default PlayerUiEffectContainer;